export default __webpack_public_path__ + "static/media/0007.dfaa6037.png";